import {
  applyMiddleware, compose, createStore, combineReducers,
} from 'redux';
import createSagaMiddleware from 'redux-saga';

import { all } from 'redux-saga/effects';
import profileReducer from './store/profile/profile.reducers';
import profileSagas from './store/profile/profile.sagas';
import animalsSagas from './store/animals/animals.sagas';
import authSagas from './store/auth/auth.sagas';
import accountingsSagas from './store/accountings/accountings.sagas';

import authReducer from './store/auth/auth.reducers';
import accountingsReducer from './store/accountings/accountings.reducers';
import animalsReducer from './store/animals/animals.reducers';
import enrollmentSagas from './store/enrollment/enrollment.sagas';
import enrollmentReducer from './store/enrollment/enrollment.reducers';

export const configureAndGetRootStore = (initialState) => {
  const reducers = combineReducers({
    profile: profileReducer,
    auth: authReducer,
    accountings: accountingsReducer,
    animals: animalsReducer,
    enrollment: enrollmentReducer,
  });

  const sagas = [
    ...profileSagas,
    ...animalsSagas,
    ...authSagas,
    ...accountingsSagas,
    ...enrollmentSagas,
  ];

  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware];

  /* eslint no-underscore-dangle: 0 */
  const devTools = (process.env.NODE_ENV !== 'production'
      && window.__REDUX_DEVTOOLS_EXTENSION__
      && window.__REDUX_DEVTOOLS_EXTENSION__({
        trace: true,
      }))
    || undefined;

  const store = devTools
    ? createStore(
      reducers,
      initialState,
      compose(applyMiddleware(...middlewares), devTools),
    )
    : createStore(
      reducers,
      initialState,
      compose(applyMiddleware(...middlewares)),
    );

  function* rootSaga() {
    yield all(sagas);
  }

  sagaMiddleware.run(rootSaga);

  return store;
};

export const store = configureAndGetRootStore();
